import { render } from "./ProfileChartButtons.vue?vue&type=template&id=6f778800"
import script from "./ProfileChartButtons.vue?vue&type=script&lang=js"
export * from "./ProfileChartButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__